/** Filipino for the assistance and administration screens of the LGU office. */
export const FIL_ASSISTANCE: Record<string, string> = {
  '0 = at the end of the program period.': '0 = sa katapusan ng panahon ng programa.',
  '0 = no limit. E.g. 90 = once every 3 months.': '0 = walang limitasyon. Hal. 90 = isang beses kada 3 buwan.',
  '4ps': '4Ps',
  'A closed program cannot be reopened.': 'Hindi na mabubuksan muli ang saradong programa.',
  'A new temporary password is shown once. They must change it at the next sign-in.': 'Isang beses lang ipapakita ang bagong pansamantalang password. Kailangan nilang palitan ito sa susunod na sign-in.',
  'Accreditation valid for (months)': 'Bisa ng akreditasyon (buwan)',
  'Action': 'Aksyon',
  'Activate': 'I-activate',
  'Active': 'Aktibo',
  'Add': 'Dagdagan',
  'Add ban period': 'Magdagdag ng ban period',
  'Add barangay': 'Magdagdag ng barangay',
  'Add category': 'Magdagdag ng kategorya',
  'Add exemption': 'Magdagdag ng exemption',
  'Add staff': 'Magdagdag ng staff',
  'Add subcategory': 'Magdagdag ng subkategorya',
  'Add the reference numbers now or before approval. You cannot check or approve your own batch.': 'Ilagay ang mga reference number ngayon o bago ang pag-apruba. Hindi mo puwedeng i-check o aprubahan ang sarili mong batch.',
  'Adjustment': 'Adjustment',
  'Adjustments': 'Mga adjustment',
  'After': 'Pagkatapos',
  'After this, the PIN must be reset with a valid ID.': 'Pagkatapos nito, kailangang i-reset ang PIN gamit ang valid ID.',
  'Age': 'Edad',
  'All': 'Lahat',
  'All accredited merchants': 'Lahat ng accredited na tindahan',
  'All barangays': 'Lahat ng barangay',
  'All programs': 'Lahat ng programa',
  'All requests': 'Lahat ng request',
  'Amount': 'Halaga',
  'Amount (₱)': 'Halaga (₱)',
  'Amount credited per person (or household) each cycle. Top-level categories only.': 'Halagang ibinibigay bawat tao (o sambahayan) kada cycle. Pangunahing kategorya lang.',
  'Amount for {c}': 'Halaga para sa {c}',
  'Amounts per cycle': 'Halaga kada cycle',
  'Any age': 'Kahit anong edad',
  'Any role': 'Kahit anong role',
  'Any status': 'Kahit anong status',
  'Anyone': 'Kahit sino',
  'Appropriation': 'Appropriation',
  'Approval steps': 'Mga hakbang ng pag-apruba',
  'Approve': 'Aprubahan',
  'Approve adjustment {n}?': 'Aprubahan ang adjustment {n}?',
  'Approve and post': 'Aprubahan at i-post',
  'Approve and post {t}?': 'Aprubahan at i-post ang {t}?',
  'Approve this export?': 'Aprubahan ang export na ito?',
  'Approved': 'Naaprubahan',
  'Approved by': 'Inaprubahan ni',
  'As set by ordinance. 0 = free.': 'Ayon sa ordinansa. 0 = libre.',
  'As written on the COMELEC certificate.': 'Ayon sa nakasulat sa COMELEC certificate.',
  'Assistance credited': 'Naibigay na tulong',
  'At least 10 characters.': 'Hindi bababa sa 10 karakter.',
  'At the end of the period': 'Sa katapusan ng panahon',
  'Audit': 'Audit',
  'Audit log': 'Audit log',
  'Balance keyword': 'Keyword para sa balanse',
  'Balances and statements. Every view is recorded in the audit log.': 'Mga balanse at statement. Bawat pagtingin ay nakatala sa audit log.',
  'Balances today': 'Balanse ngayon',
  'Barangay': 'Barangay',
  'Barangays': 'Mga barangay',
  'Basis and period': 'Batayan at panahon',
  'Batch': 'Batch',
  'Batch total': 'Kabuuan ng batch',
  'Batch {n}': 'Batch {n}',
  'Before': 'Bago',
  'Billing': 'Billing',
  'Billing period (days)': 'Billing period (araw)',
  'Budget': 'Badyet',
  'Budget (₱)': 'Badyet (₱)',
  'Budget left': 'Natitirang badyet',
  'Budget use': 'Paggamit ng badyet',
  'COMELEC exemption for {b}': 'COMELEC exemption para sa {b}',
  'COMELEC exemption {c}': 'COMELEC exemption {c}',
  'Cancel batch': 'Kanselahin ang batch',
  'Cancel this batch?': 'Kanselahin ang batch na ito?',
  'Cancelled': 'Kinansela',
  'Card-less purchases': 'Pagbili nang walang card',
  'Cards': 'Mga card',
  'Categories': 'Mga kategorya',
  'Categories and amounts': 'Mga kategorya at halaga',
  'Categories covered': 'Mga saklaw na kategorya',
  'Category': 'Kategorya',
  'Certificate number': 'Numero ng certificate',
  'Chain broken at entry {id} ({p}). Report this to ITCSI and the LGU auditor at once.': 'Sira ang chain sa entry {id} ({p}). I-report agad ito sa ITCSI at sa auditor ng LGU.',
  'Chain intact: {n} entries checked, none changed or missing.': 'Buo ang chain: {n} entry ang na-check, walang binago o nawawala.',
  'Change': 'Palitan',
  'Changing it asks every store to accept the new MOA.': 'Kapag pinalitan, hihilingin sa bawat tindahan na tanggapin ang bagong MOA.',
  'Check': 'I-check',
  'Checked': 'Na-check',
  'Checked by': 'Na-check ni',
  'Choose a program': 'Pumili ng programa',
  'Closed': 'Sarado',
  'Closing balance': 'Pangwakas na balanse',
  'Code': 'Code',
  'Conditions': 'Mga kondisyon',
  'Confirm the list, the amounts and the references match the supporting documents.': 'Tiyaking tugma ang listahan, halaga at reference sa mga supporting document.',
  'Constituent': 'Constituent',
  'Constituent number or name': 'Numero o pangalan ng constituent',
  'Constituent numbers': 'Mga numero ng constituent',
  'Constituents text this word to get their balance.': 'Ite-text ito ng mga constituent para malaman ang balanse nila.',
  'Copy': 'Kopyahin',
  'Corrections are new entries with a reason and a second person\'s approval. Nothing is edited or deleted.': 'Ang mga pagtatama ay bagong entry na may dahilan at pag-apruba ng ibang tao. Walang binabago o binubura.',
  'Cost per SMS part (₱)': 'Halaga kada SMS part (₱)',
  'Could not make the PDF. Try again.': 'Hindi magawa ang PDF. Subukan ulit.',
  'Create account': 'Gumawa ng account',
  'Credit batches': 'Mga credit batch',
  'Credited': 'Naibigay',
  'Credited to': 'Ibinibigay sa',
  'Credited under COMELEC exemption {c}, valid {f} to {to}.': 'Ibinigay sa ilalim ng COMELEC exemption {c}, may bisa mula {f} hanggang {to}.',
  'Credits': 'Mga credit',
  'Credits expire': 'Mag-e-expire ang credit',
  'Credits expire after (days)': 'Mag-e-expire ang credit pagkalipas ng (araw)',
  'Cycle': 'Cycle',
  'Days between credits': 'Araw sa pagitan ng mga credit',
  'Disable': 'I-disable',
  'Disable {n}?': 'I-disable si {n}?',
  'Disabled': 'Naka-disable',
  'Disbursement voucher': 'Disbursement voucher',
  'Disbursement voucher no.': 'Numero ng disbursement voucher',
  'Document types, separated by commas.': 'Mga uri ng dokumento, hiwalay ng kuwit.',
  'Draft': 'Draft',
  'E-mail': 'E-mail',
  'E.g. "October 2026" or "Q4 2026". A person can be credited once per cycle.': 'Hal. "Oktubre 2026" o "Q4 2026". Isang beses lang mabibigyan ang isang tao kada cycle.',
  'Each person': 'Bawat tao',
  'Each program follows its ordinance: budget, period, categories and rules.': 'Sinusunod ng bawat programa ang ordinansa nito: badyet, panahon, kategorya at patakaran.',
  'Edit ban period': 'I-edit ang ban period',
  'Edit barangay': 'I-edit ang barangay',
  'Edit category': 'I-edit ang kategorya',
  'Edit program': 'I-edit ang programa',
  'Edit {n}': 'I-edit si {n}',
  'Election bans': 'Election ban',
  'Eligibility': 'Eligibility',
  'Eligibility rules': 'Patakaran sa eligibility',
  'Eligible': 'Kwalipikado',
  'Enable': 'I-enable',
  'Enable {n}?': 'I-enable si {n}?',
  'Ends': 'Matatapos',
  'Every action, who did it and when. Entries can never be changed or deleted.': 'Bawat aksyon, sino ang gumawa at kailan. Hindi kailanman mababago o mabubura ang mga entry.',
  'Every credit is prepared, checked and approved by three different people.': 'Bawat credit ay inihahanda, chine-check at inaaprubahan ng tatlong magkakaibang tao.',
  'Everyone': 'Lahat',
  'Everyone eligible today': 'Lahat ng kwalipikado ngayon',
  'Excluded': 'Hindi kasama',
  'Excluded, with reasons': 'Hindi kasama, at ang dahilan',
  'Expired': 'Nag-expire',
  'Expired amount': 'Halagang nag-expire',
  'Expired credits': 'Mga nag-expire na credit',
  'Expiry reminder (days before)': 'Paalala bago mag-expire (araw bago)',
  'Export': 'Export',
  'Export Excel': 'I-export sa Excel',
  'Export approvals': 'Pag-apruba ng export',
  'Export request sent. Once approved, open Export approvals and export again.': 'Naipadala ang export request. Kapag naaprubahan, buksan ang Pag-apruba ng export at mag-export ulit.',
  'Exports above this many rows need approval': 'Kailangan ng pag-apruba ang export na lampas sa ganitong dami ng row',
  'Failed': 'Nabigo',
  'Farmer': 'Magsasaka',
  'Find a constituent to see their wallet.': 'Hanapin ang constituent para makita ang wallet niya.',
  'Fisherfolk': 'Mangingisda',
  'Fraud flags': 'Mga fraud flag',
  'Freeze': 'I-freeze',
  'From': 'Mula',
  'Frozen': 'Naka-freeze',
  'Fund source': 'Pinagmulan ng pondo',
  'Give only what the job needs. Roles that approve, pay or manage need two-step sign-in.': 'Ibigay lang ang kailangan sa trabaho. Kailangan ng two-step sign-in ang mga role na nag-aapruba, nagbabayad o namamahala.',
  'Hash': 'Hash',
  'Holdback while under review (%)': 'Holdback habang nire-review (%)',
  'In effect now': 'Umiiral ngayon',
  'Inactive': 'Hindi aktibo',
  'Inactive barangays cannot be picked for new records.': 'Hindi mapipili ang hindi aktibong barangay para sa bagong record.',
  'Indigent': 'Indigent',
  'Ip': 'Katutubo',
  'It has {r} rows; exports above {l} rows need another person\'s approval (Data Privacy Act).': 'May {r} row ito; kailangan ng pag-apruba ng ibang tao ang export na lampas sa {l} row (Data Privacy Act).',
  'Item status': 'Status ng item',
  'Kept in the audit log.': 'Itinatala sa audit log.',
  'LGU identity': 'Pagkakakilanlan ng LGU',
  'LGU name': 'Pangalan ng LGU',
  'LGU staff accounts and their roles. Store cashiers are added by their store owner.': 'Mga account ng staff ng LGU at ang mga role nila. Ang may-ari ng tindahan ang nagdadagdag ng cashier.',
  'Large exports of personal data need a reason and a second person (Data Privacy Act).': 'Kailangan ng dahilan at ng ibang tao ang malalaking export ng personal na datos (Data Privacy Act).',
  'Last sign-in': 'Huling sign-in',
  'Leave empty for no limit.': 'Iwanang blangko kung walang limitasyon.',
  'Leave empty to include everyone.': 'Iwanang blangko para isama ang lahat.',
  'Ledger check, expiry and fraud scan.': 'Ledger check, expiry at fraud scan.',
  'Legal basis': 'Legal na batayan',
  'Lost-card hotline': 'Hotline para sa nawawalang card',
  'MOA version': 'Bersyon ng MOA',
  'Mark as checked': 'Markahang na-check',
  'Mark this batch as checked?': 'Markahang na-check ang batch na ito?',
  'Maximum age': 'Pinakamataas na edad',
  'Merchants': 'Mga tindahan',
  'Minimum age': 'Pinakamababang edad',
  'Mobile number': 'Mobile number',
  'Monthly': 'Buwanan',
  'More than the credit\'s balance.': 'Lampas sa balanse ng credit.',
  'My requests': 'Mga request ko',
  'Name': 'Pangalan',
  'Name (English)': 'Pangalan (Ingles)',
  'Name (Filipino)': 'Pangalan (Filipino)',
  'Name or e-mail': 'Pangalan o e-mail',
  'Never': 'Hindi pa',
  'New adjustment': 'Bagong adjustment',
  'New batch': 'Bagong batch',
  'New credit batch': 'Bagong credit batch',
  'New program': 'Bagong programa',
  'New registrations must consent to this version.': 'Kailangang pumayag sa bersyong ito ang mga bagong rehistro.',
  'New temporary password for {n}': 'Bagong pansamantalang password para kay {n}',
  'Next': 'Susunod',
  'Next expiry {d}': 'Susunod na expiry {d}',
  'Nightly jobs': 'Mga gawain tuwing gabi',
  'No active programs. Activate a program first.': 'Walang aktibong programa. Mag-activate muna ng programa.',
  'No adjustments.': 'Walang adjustment.',
  'No balance left to spend.': 'Wala nang natitirang balanse.',
  'No ban periods yet. Add the COMELEC calendar for the next elections.': 'Wala pang ban period. Idagdag ang COMELEC calendar para sa susunod na halalan.',
  'No barangays yet.': 'Wala pang barangay.',
  'No batches yet.': 'Wala pang batch.',
  'No batches.': 'Walang batch.',
  'No crediting during these periods unless a COMELEC exemption covers it.': 'Walang pagbibigay ng credit sa mga panahong ito maliban kung saklaw ng COMELEC exemption.',
  'No entries match.': 'Walang tugmang entry.',
  'No limit': 'Walang limitasyon',
  'No match.': 'Walang tugma.',
  'No movements in this period.': 'Walang galaw sa panahong ito.',
  'No programs yet.': 'Wala pang programa.',
  'No requests.': 'Walang request.',
  'No staff match.': 'Walang tugmang staff.',
  'Nobody excluded.': 'Walang hindi kasama.',
  'Nobody in this batch.': 'Walang tao sa batch na ito.',
  'Nobody qualifies yet.': 'Wala pang kwalipikado.',
  'None': 'Wala',
  'Not set up': 'Hindi pa naka-set up',
  'Note': 'Tala',
  'Nothing has expired.': 'Walang nag-expire.',
  'Number': 'Numero',
  'Obligation request': 'Obligation request',
  'Obligation request no.': 'Numero ng obligation request',
  'Off': 'Naka-off',
  'On': 'Naka-on',
  'One credit per household instead of per person.': 'Isang credit bawat sambahayan sa halip na bawat tao.',
  'One per household': 'Isa bawat sambahayan',
  'One per line or separated by commas. Each is still checked against the rules.': 'Isa bawat linya o hiwalay ng kuwit. Tsine-check pa rin ang bawat isa ayon sa patakaran.',
  'One time': 'Isang beses',
  'Only the LGU name and seal appear on cards, slips, SMS and reports. No names, photos or slogans of officials (COA Circular 2013-004, DILG anti-epal policy).': 'Pangalan at selyo lang ng LGU ang lalabas sa card, slip, SMS at report. Walang pangalan, larawan o slogan ng opisyal (COA Circular 2013-004, DILG anti-epal policy).',
  'Only these constituent numbers': 'Ang mga numerong ito lang ng constituent',
  'Opening balance': 'Panimulang balanse',
  'Order': 'Pagkakasunod',
  'Ordinance or resolution number. Funds may only be used for this program (LGC Sec. 336).': 'Numero ng ordinansa o resolusyon. Para lang sa programang ito ang pondo (LGC Sec. 336).',
  'PDF': 'PDF',
  'PIN rules': 'Patakaran sa PIN',
  'PSGC code': 'PSGC code',
  'Past': 'Nakaraan',
  'Pay up to the cap, the rest in cash': 'Bayaran hanggang sa cap, ang sobra ay cash',
  'Pending': 'Naghihintay',
  'People': 'Tao',
  'People in this batch': 'Mga tao sa batch na ito',
  'Per day': 'Bawat araw',
  'Per household': 'Bawat sambahayan',
  'Per person per day': 'Bawat tao bawat araw',
  'Per person per month': 'Bawat tao bawat buwan',
  'Per purchase': 'Bawat bili',
  'Per store per day': 'Bawat tindahan bawat araw',
  'Period': 'Panahon',
  'Posted': 'Na-post',
  'Posts the credits that were not posted yet. Already posted credits are not repeated.': 'Ipo-post ang mga credit na hindi pa na-post. Hindi na uulitin ang mga na-post na.',
  'Pregnant': 'Buntis',
  'Prepare a credit batch': 'Maghanda ng credit batch',
  'Prepare batch': 'Ihanda ang batch',
  'Prepared by': 'Inihanda ni',
  'Previous': 'Nakaraan',
  'Price above the cap': 'Presyong lampas sa cap',
  'Printed on the back of every card.': 'Nakalimbag sa likod ng bawat card.',
  'Privacy': 'Privacy',
  'Privacy notice version': 'Bersyon ng privacy notice',
  'Program': 'Programa',
  'Programs': 'Mga programa',
  'Programs covered': 'Mga saklaw na programa',
  'Province': 'Lalawigan',
  'Purchase': 'Bili',
  'Purchase cancelled': 'Kinanselang bili',
  'Purchases per card per day': 'Bili bawat card bawat araw',
  'Pwd': 'PWD',
  'Quarterly': 'Kada tatlong buwan',
  'Reason': 'Dahilan',
  'Record': 'Record',
  'Record type': 'Uri ng record',
  'Refund': 'Refund',
  'Refuse the item': 'Tanggihan ang item',
  'Reject': 'Tanggihan',
  'Reject adjustment {n}?': 'Tanggihan ang adjustment {n}?',
  'Reject this export?': 'Tanggihan ang export na ito?',
  'Rejected': 'Tinanggihan',
  'Remaining budget': 'Natitirang badyet',
  'Remove this ban period?': 'Alisin ang ban period na ito?',
  'Remove {n} people from the batch?': 'Alisin ang {n} tao sa batch?',
  'Remove {n} selected': 'Alisin ang {n} napili',
  'Renewal reminder (days before)': 'Paalala sa renewal (araw bago)',
  'Reopen': 'Buksan muli',
  'Reopen as a draft?': 'Buksan muli bilang draft?',
  'Reopen as draft': 'Buksan muli bilang draft',
  'Replacement fee (₱)': 'Bayad sa kapalit (₱)',
  'Request approval': 'Humingi ng pag-apruba',
  'Requested': 'Hiniling',
  'Required documents': 'Mga kailangang dokumento',
  'Reset': 'I-reset',
  'Reset password': 'I-reset ang password',
  'Reset the password of {n}?': 'I-reset ang password ni {n}?',
  'Reset two-step': 'I-reset ang two-step',
  'Reset two-step sign-in for {n}?': 'I-reset ang two-step sign-in ni {n}?',
  'Resume posting': 'Ituloy ang pag-post',
  'Resume posting?': 'Ituloy ang pag-post?',
  'Return': 'Ibalik',
  'Return to maker': 'Ibalik sa gumawa',
  'Return to the maker?': 'Ibalik sa gumawa?',
  'Returned by {who}: {why}': 'Ibinalik ni {who}: {why}',
  'Role': 'Role',
  'Roles': 'Mga role',
  'Rows': 'Mga row',
  'Rules': 'Mga patakaran',
  'Rules the LGU can change without a developer. Every change is in the audit log.': 'Mga patakarang mababago ng LGU nang walang developer. Nakatala sa audit log ang bawat pagbabago.',
  'Run at hour (0–23, Manila)': 'Patakbuhin sa oras (0–23, Manila)',
  'SMS': 'SMS',
  'Save exemption': 'I-save ang exemption',
  'Save program': 'I-save ang programa',
  'Save {n} changes': 'I-save ang {n} pagbabago',
  'Saved': 'Na-save',
  'Search programs': 'Maghanap ng programa',
  'Seconds between sales at one store': 'Segundo sa pagitan ng benta sa isang tindahan',
  'Sectors': 'Mga sektor',
  'Select': 'Piliin',
  'Send for approval': 'Ipadala para aprubahan',
  'Senior': 'Senior citizen',
  'Settings': 'Mga setting',
  'Settings saved.': 'Na-save ang mga setting.',
  'Short lock (minutes)': 'Maikling lock (minuto)',
  'Short name': 'Maikling pangalan',
  'Showing the first 300 of {n}.': 'Ipinapakita ang unang 300 sa {n}.',
  'Showing the first 500 of {n}.': 'Ipinapakita ang unang 500 sa {n}.',
  'Shown only now. Give it to the person directly, never by chat or e-mail. They choose their own password at the first sign-in.': 'Ngayon lang ipapakita. Ibigay ito nang personal, hindi sa chat o e-mail. Pipili sila ng sariling password sa unang sign-in.',
  'Shown to the approver and in the audit report.': 'Makikita ng mag-aapruba at sa audit report.',
  'Solo parent': 'Solo parent',
  'Someone else must approve': 'Ibang tao ang dapat mag-apruba',
  'Spending limits (₱)': 'Limitasyon sa paggastos (₱)',
  'Spending rules': 'Patakaran sa paggastos',
  'Spent': 'Nagastos',
  'Staff users': 'Mga staff user',
  'Starts': 'Magsisimula',
  'Statement': 'Statement',
  'Status': 'Status',
  'Store closes': 'Sumasara ang tindahan',
  'Store opens': 'Nagbubukas ang tindahan',
  'Stores per card per day': 'Tindahan bawat card bawat araw',
  'Submit': 'Isumite',
  'Submit for checking': 'Isumite para i-check',
  'Submit for checking?': 'Isumite para i-check?',
  'Submitted': 'Naisumite',
  'Super Admin only': 'Super Admin lang',
  'System': 'System',
  'Take back': 'Bawiin',
  'Temporary password for {n}': 'Pansamantalang password para kay {n}',
  'The credits go to {n} wallets at once and each person gets an SMS. This cannot be undone; mistakes are fixed with adjustments.': 'Mapupunta agad ang mga credit sa {n} wallet at may SMS ang bawat tao. Hindi na ito mababawi; inaayos ang mali gamit ang adjustment.',
  'The requester can download it once.': 'Isang beses itong mada-download ng humiling.',
  'They are signed out everywhere and cannot sign in.': 'Masa-sign out sila sa lahat ng device at hindi makakapag-sign in.',
  'This batch is more than the budget left. Remove people or ask for a budget change before approval.': 'Lampas sa natitirang badyet ang batch na ito. Mag-alis ng tao o humingi ng pagbabago sa badyet bago aprubahan.',
  'This export needs approval': 'Kailangan ng pag-apruba ang export na ito',
  'This person has no live credits.': 'Walang aktibong credit ang taong ito.',
  'This program is {s}. Changes apply to new credits.': 'Ang programang ito ay {s}. Sa mga bagong credit lang ang pagbabago.',
  'Times above similar stores': 'Ilang beses na mas mataas sa kahalintulad na tindahan',
  'To': 'Hanggang',
  'Top level (funded by programs)': 'Pangunahin (pinopondohan ng programa)',
  'Top-level categories are funded by programs. Subcategories group the approved products.': 'Pinopondohan ng programa ang mga pangunahing kategorya. Pinagsasama-sama ng subkategorya ang mga aprubadong produkto.',
  'Total': 'Kabuuan',
  'Turn off to choose the merchants for this program.': 'I-off para piliin ang mga tindahan para sa programang ito.',
  'Two-step required': 'Kailangan ng two-step',
  'Two-step sign-in': 'Two-step sign-in',
  'Under': 'Sa ilalim ng',
  'Unfreeze': 'I-unfreeze',
  'Unspent credits move to the expired account at the end of their period and are reported for budget reversion.': 'Ang hindi nagastos na credit ay inililipat sa expired account sa katapusan ng panahon nito at iniuulat para sa reversion ng badyet.',
  'Upcoming': 'Paparating',
  'Upload the certificate (PDF or photo)': 'I-upload ang certificate (PDF o larawan)',
  'Uploading…': 'Nag-a-upload…',
  'Use this when they lost their phone. They set up a new authenticator at their next sign-in.': 'Gamitin ito kapag nawala ang phone nila. Magse-set up sila ng bagong authenticator sa susunod na sign-in.',
  'Used': 'Nagamit',
  'Used at the start of SMS, e.g. "LGU".': 'Ginagamit sa simula ng SMS, hal. "LGU".',
  'Used in registration, eligibility rules and the coverage map.': 'Ginagamit sa rehistro, patakaran sa eligibility at coverage map.',
  'User': 'User',
  'Valid from': 'May bisa mula',
  'Valid to': 'May bisa hanggang',
  'Verify chain': 'I-verify ang chain',
  'Void and refund rate (%)': 'Rate ng void at refund (%)',
  'Waiting': 'Naghihintay',
  'Waiting for me': 'Naghihintay sa akin',
  'Wallets': 'Mga wallet',
  'When': 'Kailan',
  'Which credit': 'Aling credit',
  'While frozen, no credits are posted and stores cannot charge this program.': 'Habang naka-freeze, walang ipo-post na credit at hindi makakasingil ang mga tindahan sa programang ito.',
  'Who': 'Sino',
  'Who is eligible': 'Sino ang kwalipikado',
  'Who to include': 'Sino ang isasama',
  'Why': 'Bakit',
  'Why do you need it?': 'Bakit mo ito kailangan?',
  'Write a little more.': 'Magsulat pa nang kaunti.',
  'Wrong PINs before a full lock': 'Maling PIN bago ang buong lock',
  'Wrong PINs before a short lock': 'Maling PIN bago ang maikling lock',
  'You': 'Ikaw',
  'You already did a step on this batch, so someone else must approve it.': 'Nakagawa ka na ng hakbang sa batch na ito, kaya ibang tao ang dapat mag-apruba.',
  'You prepared this batch, so someone else must check it.': 'Ikaw ang naghanda ng batch na ito, kaya ibang tao ang dapat mag-check.',
  'Youth': 'Kabataan',
  'e.g. 2028 national and local elections': 'hal. 2028 pambansa at lokal na halalan',
  'expires {d}': 'mag-e-expire {d}',
  'of {a}': 'sa {a}',
  'of {b}': 'sa {b}',
  'to': 'hanggang',
  '{a} is posted to the ledger at once.': 'Agad na ipo-post sa ledger ang {a}.',
  '{a} this program?': '{a} ang programang ito?',
  '{c} credited of {b}': '{c} naibigay sa {b}',
  '{c} credited, {r} left': '{c} naibigay, {r} natitira',
  '{n} credits could not be posted. Their reasons are listed below.': 'Hindi na-post ang {n} credit. Nakalista sa ibaba ang mga dahilan.',
  '{n} days after crediting': '{n} araw pagkatapos ibigay',
  '{n} entries': '{n} entry',
  '{n} people': '{n} tao',
  '{n} selected': '{n} napili',
  '{o} credited but not yet spent': '{o} naibigay pero hindi pa nagagastos',
};
